/**
 * 404 Not Found page
 * Displayed when users navigate to a non-existent route
 */

import { Home, ArrowLeft, Search } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/Button';

export function NotFound() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-canvas flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* 404 Illustration */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-brand/10 text-brand mb-4">
            <Search className="w-12 h-12" />
          </div>
          <h1 className="text-6xl font-bold text-primary mb-2">404</h1>
        </div>

        {/* Error Message */}
        <h2 className="text-section-title text-primary mb-2">
          Page not found
        </h2>
        <p className="text-body text-secondary mb-8">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
          Check the URL or navigate back to a known page.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            onClick={handleGoBack}
            variant="secondary"
            className="gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
          <Link to="/">
            <Button variant="primary" className="gap-2 w-full sm:w-auto">
              <Home className="w-4 h-4" />
              Go to Dashboard
            </Button>
          </Link>
        </div>

        {/* Help Text */}
        <p className="mt-8 text-sm text-muted">
          If you believe this is an error, please contact support.
        </p>
      </div>
    </div>
  );
}

export default NotFound;
